import axios from "axios";

const API_BASE_URL = (
  process.env.REACT_APP_API_URL ||
  "https://api.bsangam.com"
).replace(/\/$/, "");

const BASE_URL =
  `${API_BASE_URL}/posts`;

// ==========================
// 📝 CREATE POST
// ==========================
export const createPostApi =
  async (
    formData: FormData
  ) => {
    try {
      const res =
        await axios.post(
          `${BASE_URL}/create`,
          formData,
          {
            headers: {
              "Content-Type":
                "multipart/form-data",
            },
          }
        );

      return res.data;
    } catch (error: any) {
      return {
        status: false,
        message:
          error?.response?.data
            ?.message ||
          "Failed to create post",
      };
    }
  };

// ==========================
// 🌍 GET GLOBAL POSTS
//
// Guest:
// GET /posts/all
//
// Logged-in:
// GET /posts/all?user_id=43
// ==========================
export const getAllPostsApi =
  async (
    user_id?:
      | number
      | null
  ) => {
    try {
      const params: any = {};

      if (
        user_id &&
        Number(user_id) > 0
      ) {
        params.user_id =
          Number(user_id);
      }

      const res =
        await axios.get(
          `${BASE_URL}/all`,
          {
            params,
          }
        );

      return res.data;
    } catch (error: any) {
      return {
        status: false,
        data: [],
        message:
          error?.response?.data
            ?.message ||
          "Failed to fetch posts",
      };
    }
  };

// ==========================
// ❤️ TOGGLE LIKE
// ==========================
export const toggleReactionApi =
  async (
    payload: any
  ) => {
    try {
      const res =
        await axios.post(
          `${BASE_URL}/reaction/toggle`,
          payload
        );

      return res.data;
    } catch (error: any) {
      return {
        status: false,
        message:
          error?.response?.data
            ?.message ||
          "Failed to update reaction",
      };
    }
  };

// ==========================
// 📊 LIKE INFO
// ==========================
export const getReactionInfoApi =
  async (
    post_id: number,
    client_id: number
  ) => {
    try {
      const res =
        await axios.get(
          `${BASE_URL}/reaction/info`,
          {
            params: {
              post_id,
              client_id,
            },
          }
        );

      return res.data;
    } catch (error: any) {
      return {
        status: false,
        data: null,
        message:
          error?.response?.data
            ?.message ||
          "Failed to fetch reaction info",
      };
    }
  };

// ==========================
// 💬 ADD COMMENT
// ==========================
export const addCommentApi =
  async (
    payload: any
  ) => {
    try {
      const res =
        await axios.post(
          `${BASE_URL}/comment/add`,
          payload
        );

      return res.data;
    } catch (error: any) {
      return {
        status: false,
        message:
          error?.response?.data
            ?.message ||
          "Failed to add comment",
      };
    }
  };

// ==========================
// 💬 GET COMMENTS
// ==========================
export const getCommentsApi =
  async (
    post_id: number
  ) => {
    try {
      const res =
        await axios.get(
          `${BASE_URL}/comment/${post_id}`
        );

      return res.data;
    } catch (error: any) {
      return {
        status: false,
        data: [],
        message:
          error?.response?.data
            ?.message ||
          "Failed to fetch comments",
      };
    }
  };

// ==========================
// 📌 GET POSTS BY CLIENT ID
//
// Guest:
// GET /posts/all/:client_id
//
// Logged-in:
// GET /posts/all/:client_id?user_id=43
// ==========================
export const getAllPostsByClientIdApi =
  async (
    client_id: number,
    user_id?: number
  ) => {
    try {
      const params: any = {};

      if (
        user_id &&
        Number(user_id) > 0
      ) {
        params.user_id =
          Number(user_id);
      }

      const res =
        await axios.get(
          `${BASE_URL}/all/${client_id}`,
          {
            params,
          }
        );

      return res.data;
    } catch (error: any) {
      return {
        status: false,
        data: [],
        message:
          error?.response?.data
            ?.message ||
          "Failed to fetch client posts",
      };
    }
  };

// ==========================
// 📌 GET POST BY ID
// ==========================
export const getPostByIdApi =
  async (
    post_id: number
  ) => {
    try {
      const res =
        await axios.get(
          `${BASE_URL}/${post_id}`
        );

      return res.data;
    } catch (error: any) {
      return {
        status: false,
        data: null,
        message:
          error?.response?.data
            ?.message ||
          "Failed to fetch post",
      };
    }
  };

// ==========================
// 🔥 GLOBAL MOST VIEWED POSTS
//
// Guest:
// GET /posts/most-viewed
//
// Logged-in:
// GET /posts/most-viewed?user_id=43
//
// IMPORTANT:
// No client_id here.
// This is GLOBAL trending.
// ==========================
export const getMostViewedPostsApi =
  async (
    user_id?:
      | number
      | null
  ) => {
    try {
      const params: any = {};

      if (
        user_id &&
        Number(user_id) > 0
      ) {
        params.user_id =
          Number(user_id);
      }

      const res =
        await axios.get(
          `${BASE_URL}/most-viewed`,
          {
            params,
          }
        );

      return res.data;
    } catch (error: any) {
      return {
        status: false,
        data: [],
        message:
          error?.response?.data
            ?.message ||
          "Failed to fetch most viewed posts",
      };
    }
  };

// ==========================
// 👤 OLD USER FOLLOWED CLUB FEED
//
// Kept for backward compatibility.
// ==========================
export const getUserFeedPostsApi =
  async (
    user_id: number
  ) => {
    try {
      const res =
        await axios.get(
          `${BASE_URL}/user-feed/${user_id}`
        );

      return res.data;
    } catch (error: any) {
      return {
        status: false,
        data: [],
        message:
          error?.response?.data
            ?.message ||
          "Failed to fetch user feed",
      };
    }
  };

// ==========================
// 🔥 OLD USER MOST VIEWED POSTS
//
// Kept for backward compatibility.
// New global Trending News should use
// getMostViewedPostsApi(user_id).
// ==========================
export const getUserMostViewedPostsApi =
  async (
    user_id: number
  ) => {
    try {
      const res =
        await axios.get(
          `${BASE_URL}/user-most-viewed/${user_id}`
        );

      return res.data;
    } catch (error: any) {
      return {
        status: false,
        data: [],
        message:
          error?.response?.data
            ?.message ||
          "Failed to fetch user most viewed posts",
      };
    }
  };
